import { render } from "./albbFormItem.vue?vue&type=template&id=6e5c829e"
import script from "./albbFormItem.vue?vue&type=script&lang=js"
export * from "./albbFormItem.vue?vue&type=script&lang=js"

import "./albbFormItem.vue?vue&type=style&index=0&id=6e5c829e&lang=scss"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/componentBase/AlbbPublishProduct/components/albbFormItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6e5c829e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6e5c829e', __exports__)) {
    api.reload('6e5c829e', __exports__)
  }
  
  module.hot.accept("./albbFormItem.vue?vue&type=template&id=6e5c829e", () => {
    api.rerender('6e5c829e', render)
  })

}


export default __exports__